import React from 'react';
import {
  IndentedTextContent,
  StickyTableData,
  TableRow as StyledTableRow,
} from '../../TableRow.styles';
import { Text } from '../../../../../../../../../../../../../../CommonComponents/OPL/Text/Text';
import { Tooltip } from '../../../../../../../../../../../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { Icon } from '../../../../../../../../../../../../../../CommonComponents/OPL/Icon/Icon';
import { Asset } from '../../../../../../FlowTable.meta';
import { Value } from '../Value/Value';
import { TruncatedText } from '../../../../../../../../../../../../../../CommonComponents/OPL/Text/TruncatedText';

interface Props {
  assets: Record<string, Asset[]>;
  collapsableHeaderIds: string[];
  hasHeaderSelected(id: number): boolean;
  hasShowCollapsed(id: number): boolean;
}

export const AssetTableRow = ({
  assets,
  collapsableHeaderIds,
  hasHeaderSelected,
  hasShowCollapsed,
}: Props) => {
  return (
    <>
      {Object.entries(assets).map(([assetId, assetData]) => {
        return (
          <StyledTableRow key={assetId}>
            <StickyTableData columnPosition={0}>
              <IndentedTextContent indentation={3}>
                <TruncatedText fontWeight={400} textAlign="left">
                  {assetData[0].name}
                </TruncatedText>
              </IndentedTextContent>
            </StickyTableData>

            {assetData.map(({ value, collapsed, headerId, additionalInfo }, index) => {
              if (hasHeaderSelected(headerId)) {
                return null;
              }
              const isCollapsableHeader = collapsableHeaderIds.includes(headerId.toString());

              const isCollapsed = hasShowCollapsed(headerId) ? !collapsed : collapsed;

              if (isCollapsableHeader && isCollapsed) {
                return null;
              }

              return (
                <React.Fragment key={`asset-${index}`}>
                  {index === 0 ? (
                    <StickyTableData columnPosition={1}>
                      <Text variant="tabular" textAlign="right">
                        <Value value={value} />

                        {additionalInfo && (
                          <Tooltip content={additionalInfo}>
                            <Icon
                              ml="4"
                              className="fas fa-exclamation-triangle"
                              color="warning.400"
                            />
                          </Tooltip>
                        )}
                      </Text>
                    </StickyTableData>
                  ) : (
                    <td>
                      <Text variant="tabular" textAlign="right">
                        <Value value={value} />

                        {additionalInfo && (
                          <Tooltip content={additionalInfo}>
                            <Icon
                              ml="4"
                              className="fas fa-exclamation-triangle"
                              color="warning.400"
                            />
                          </Tooltip>
                        )}
                      </Text>
                    </td>
                  )}
                </React.Fragment>
              );
            })}
          </StyledTableRow>
        );
      })}
    </>
  );
};
